import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { CcServiceDemoCardHeader } from "@/components/services/shared/CcServiceDemoCardHeader";

type GrowthFeatureCardProps = {
  title: string;
  description: string;
  badge?: string;
  icon?: LucideIcon;
  className?: string;
  children: ReactNode;
};

export function GrowthFeatureCard({
  title,
  description,
  badge,
  icon,
  className,
  children,
}: GrowthFeatureCardProps) {
  return (
    <article
      className={["cc-growth-features__card", "cc-service-demo-card", className]
        .filter(Boolean)
        .join(" ")}
    >
      <CcServiceDemoCardHeader
        title={title}
        description={description}
        badge={badge}
        icon={icon}
      />
      <div className="cc-growth-features__card-body">
        <div className="cc-growth-features__card-visual">{children}</div>
      </div>
    </article>
  );
}
